import { Chart } from "chart.js/auto";
import { useEffect, useRef } from "react";
import React from "react";
import "./stackedbarchart.scss";
import { selectEveryNth } from "../../helpers/helpers";

const StackedBarChart = (props) => {
  const labels = ["60", "65", "70", "75", "80", "85", "90", "95", "100"]; // eslint-disable-line
  const screenWidth = screen.width; // eslint-disable-line
  let min = 0;
  let max = 0;
  let label = [];
  let statePension = [];
  let tptIncome = [];
  let dbpensionIncome = [];
  let spIndex = 0;
  if (props?.activeChart === "flexi") {
    label =
      props?.flexi &&
      props?.flexi?.incomeGraph
        ?.filter((item) => item.age <= 100) // Filter the array to include only ages <= 100
        ?.map((item) => item.age);
    min = label[0];
    max = label[label?.length - 1];
    statePension =
      props?.flexi &&
      props?.flexi?.incomeGraph?.map((item) => item?.statePension);
    tptIncome =
      props?.flexi && props?.flexi?.incomeGraph?.map((item) => item?.tptIncome);
    dbpensionIncome =
      props?.flexi &&
      props?.flexi?.incomeGraph?.map((item) => item?.dbPensionIncome);
  }
  if (props?.activeChart === "manage") {
    label =
      props?.manage &&
      props?.manage?.managedIncomeResponseDTOList?.map((item) => item?.age);
    min = label[0];
    max = label[label?.length - 1];
    statePension =
      props?.manage &&
      props?.manage?.managedIncomeResponseDTOList?.map(
        (item) => item?.spaAmount, // eslint-disable-line
      );
    tptIncome =
      props?.manage &&
      props?.manage?.managedIncomeResponseDTOList?.map(
        (item) => item?.perYearvalue, // eslint-disable-line
      );
  }
  if (props?.activeChart === "annuity") {
    label =
      props?.annuity &&
      props?.annuity?.managedIncomeResponseDTOList?.map((item) => item?.age);
    min = label[0];
    max = label[label?.length - 1];
    statePension =
      props?.annuity &&
      props?.annuity?.managedIncomeResponseDTOList?.map(
        (item) => item?.spaAmount, // eslint-disable-line
      );
    tptIncome =
      props?.annuity &&
      props?.annuity?.managedIncomeResponseDTOList?.map(
        (item) => item?.perYearvalue, // eslint-disable-line
      );
  }
  if (statePension?.length > 0) {
    spIndex = statePension.findIndex((val) => val > 0);
  }

  const data = {
    labels: label,
    datasets:
      props?.activeChart === "flexi"
        ? [
            {
              label: "DB pension",
              data: dbpensionIncome,
              backgroundColor: "#008500",
            },
            {
              label: "State pension",
              data: statePension,
              backgroundColor: "#151f6d",
            },
            {
              label: "DC income",
              data: tptIncome,
              backgroundColor: "#a51890",
            },
          ]
        : [
            {
              label: "State pension",
              data: statePension,
              backgroundColor: "#151f6d",
            },
            {
              label: "DC income",
              data: tptIncome,
              backgroundColor: "#a51890",
            },
          ],
  };

  var options = {
    type: "bar",
    data: data,
    options: {
      layout: {
        padding: {
          right: 0,
        },
      },
      plugins: {
        legend: false,
        tooltip: {
          enabled: true,
        },
      },
      barPercentage: 0.9,
      categoryPercentage: 1,
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          stacked: true,
          grid: {
            display: false,
          },
          ticks: {
            padding: 10,
            color: "#151f6d",
            maxTicksLimit: Math.floor((max - min) / 5) + 1,
            font: {
              family: "calibri",
              size: 16,
            },
          },
          title: {
            display: true,
            text: "Age",
            font: {
              size: 16,
              weight: "bold",
            },
            color: "#151f6d",
            padding: {
              top: screenWidth <= 768 ? 0 : 15,
            },
          },
        },
        y: {
          stacked: true,
          grid: {
            color: "#d0d2e2",
            drawTicks: false,
            lineWidth: 2,
          },
          ticks: {
            padding: 10,
            color: "#151f6d",
            font: {
              family: "calibri",
              size: 16,
            },
            callback: function (value) {
              if (value >= 1000) {
                return "£" + value / 1000 + "k";
              }
              return "£" + value;
            },
          },
          title: {
            display: true,
            text:
              props?.activeChart === "flexi"
                ? "Estimated income p.a."
                : "Income",
            font: {
              size: 16,
              weight: "bold",
            },
            color: "#151f6d",
          },
        },
      },
    },
    plugins: [
      //TO DO need to remove once chart issue fixed
      props?.activeChart === "manage"
        ? {
            id: "backgrounds",
            beforeDraw: (chart) => {
              const {
                ctx,
                scales: { x, y },
              } = chart;
              const yScale = chart.scales.y;

              const topValue = yScale.ticks[0].value;
              const bottomValue = yScale.ticks[yScale.ticks.length - 1].value;

              let barWidth = 0;
              const xLabels = chart.scales.x;
              barWidth =
                x.getPixelForValue(xLabels.ticks[1].label) -
                x.getPixelForValue(xLabels.ticks[0].label);
              const items = xLabels.getLabelItems();
              const { data } = chart.getDatasetMeta(0);
              const newData = selectEveryNth(data, 5);
              for (let i = 0; i < items.length; i++) {
                if (i % 2 === 1) {
                  const { x, width } = newData[i];
                  const newX = x - width / 2;

                  ctx.save();
                  ctx.fillStyle = "#f8f8f8";
                  ctx.fillRect(
                    newX,
                    y.getPixelForValue(topValue),
                    barWidth,
                    y.getPixelForValue(bottomValue) -
                      y.getPixelForValue(topValue), // eslint-disable-line
                  );
                  ctx.restore();
                }
              }
            },
          }
        : props?.activeChart === "flexi"
          ? {
              id: "backgrounds",
              beforeDraw: (chart) => {
                const {
                  ctx,
                  scales: { x, y },
                } = chart;
                const yScale = chart.scales.y;

                const topValue = yScale.ticks[0].value;
                const bottomValue = yScale.ticks[yScale.ticks.length - 1].value;

                let barWidth = 0;
                const xLabels = chart.scales.x;
                barWidth =
                  x.getPixelForValue(xLabels.ticks[1].label) -
                  x.getPixelForValue(xLabels.ticks[0].label);
                const items = xLabels.getLabelItems();
                const { data } = chart.getDatasetMeta(0);
                const newData = selectEveryNth(data, 5);
                for (let i = 0; i < items.length; i++) {
                  if (i % 2 === 1) {
                    const { x, width } = newData[i];
                    const newX = x - width / 2;

                    ctx.save();
                    ctx.fillStyle = "#f8f8f8";
                    ctx.fillRect(
                      newX,
                      y.getPixelForValue(topValue),
                      barWidth,
                      y.getPixelForValue(bottomValue) -
                        y.getPixelForValue(topValue), // eslint-disable-line
                    );
                    ctx.restore();
                  }
                }
              },
            }
          : "",
      //To do - need to enable after Statepension calculation
      // {
      //   beforeDraw: (chart) => {
      //     if (chart.tooltip?._active?.length) {
      //       let x =
      //         chart.tooltip._active[0].element.x -
      //         chart.tooltip._active[0].element.width / 1.8;
      //       let yAxis = chart.scales.y;
      //       let ctx = chart.ctx;
      //       ctx.save();
      //       ctx.beginPath();
      //       ctx.moveTo(x, yAxis.top);
      //       ctx.lineTo(x, yAxis.bottom + 50);
      //       ctx.setLineDash([5, 5]);
      //       ctx.lineWidth = 1.5;
      //       ctx.strokeStyle = "#7379a7";
      //       ctx.stroke();

      //       ctx.beginPath();
      //       ctx.arc(x, yAxis.bottom + 50, 5, 0, 2 * Math.PI);
      //       ctx.fillStyle = "#7379a7";
      //       ctx.fill();

      //       ctx.fillStyle = "black";
      //       ctx.font = "12px Arial";
      //       ctx.textAlign = "center";
      //       ctx.fillText("State pension age", x, yAxis.bottom + 50 + 5 + 10);

      //       ctx.restore();
      //     }
      //   },
      // },
      {
        afterDraw: (chart) => {
          if (props?.spSwitch === true) {
            const meta = chart.getDatasetMeta(1);
            const barX =
              meta.data[spIndex]?.x - meta.data[spIndex]?.width / 1.8;

            const ctx = chart.ctx;

            ctx.save();
            ctx.beginPath();
            ctx.moveTo(barX, chart.chartArea.top);
            ctx.lineTo(barX, chart.chartArea.bottom + 50);
            ctx.setLineDash([5, 5]);
            ctx.lineWidth = 1.5;
            ctx.strokeStyle = "#7379a7";
            ctx.stroke();

            ctx.beginPath();
            ctx.arc(barX, chart.chartArea.bottom + 50, 5, 0, 2 * Math.PI);
            ctx.fillStyle = "#7379a7";
            ctx.fill();

            ctx.fillStyle = "#151f6d";
            ctx.font = "12px Arial";
            ctx.textAlign = "center";
            ctx.fillText(
              "State pension age",
              barX,
              chart.chartArea.bottom + 50 + 5 + 10, // eslint-disable-line
            );

            ctx.restore();
          }
        },
      },
    ],
  };
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;

    const ctx = canvas.getContext("2d");

    const chart = new Chart(ctx, options);

    return () => {
      if (chart.destroy) {
        chart.destroy();
      }
    };
  }, []);

  return (
    <div className="parent-chart">
      <canvas ref={canvasRef} data-testid="stacked-bar-chart"></canvas>
    </div>
  );
};

export default StackedBarChart;
